import { findAll, findById, create, update, deleteRequest } from '@/services/integration/integrationService'
import Vue from 'vue'

const state = {
  integrations: [],
  integration: {},
  paginatedIntegrations: {},
}

const getters = {
  integrations: (state) => state.integrations,
  integration: (state) => state.integration,
}

const actions = {
  async fetchIntegrations({commit, dispatch, rootState}) {
    commit('setIsLoading', true)
    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }
    const params = { ...defaultParams, ...rootState.filters.filters }
    try {
      const { data } = await findAll(params)
      const { result } = await data
      commit('setIntegrations', result)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
  async fetchIntegration({commit, dispatch}, id) {
    commit('setIsLoading', true)
    try {
      const { data } = await findById(id)
      commit('setIntegration', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
  async createIntegration({commit, dispatch}, integration) {
    commit('setIsLoading', true)
    try {
      const { data } = await create(integration)
      dispatch('showSuccessMessage', 'Integration criada com sucesso!')
    } catch ({ data }) {
      if (data.errors) {
        let errorMessage = ''
        data.errors.forEach((error) => {
          errorMessage += Vue.i18n.translate('mission.label.' + error.field) + ": " + error.message
        })
        dispatch('showErrorMessage', errorMessage)
      } else {
        dispatch('showErrorMessage', data.message)
      }
    } finally {
      dispatch('fetchIntegrations')
      commit('setIsLoading', false)
    }
  },

  async updateIntegration({ commit, dispatch}, integration){
    commit('setIsLoading', true)
    try {
      const { data } = await update(integration)
      dispatch('showSuccessMessage', 'Integration atualizada com sucesso!')
    } catch ({ data }) {
      if (data.errors) {
        let errorMessage = ''
        data.errors.forEach((error) => {
          errorMessage += Vue.i18n.translate('mission.label.' + error.field) + ": " + error.message
        })
        dispatch('showErrorMessage', errorMessage)
      } else {
        dispatch('showErrorMessage', data.message)
      }
    } finally {
      dispatch('fetchIntegrations')
      commit('setIsLoading', false)
    }
  },

  async deleteIntegration({ commit, dispatch}, id){
    commit('setIsLoading', true)
    try {
      const { data } = await deleteRequest(id)
      dispatch('showSuccessMessage', 'Integration deletada com sucesso!')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      dispatch('fetchIntegrations')
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setIntegrations: (state, integrations) => {
    state.integrations = integrations
  },
  setIntegration: (state, integration) => {
    state.integration = integration
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}